import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { getOperationIcon } from "./nocUtils";

export const AnalyticsTab = ({ stats }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2" data-testid="analytics-tab">
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Operations by Type</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {stats?.by_operation_type?.map((item) => (
              <div key={item.type} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {getOperationIcon(item.type)}
                  <span className="text-sm">{item.type}</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-32 h-2 bg-muted rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary"
                      style={{ width: `${(item.count / stats.total_operations) * 100}%` }}
                    />
                  </div>
                  <span className="text-sm font-mono w-12 text-right">{item.count}</span>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Top Users by Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {stats?.by_user?.map((item, idx) => (
              <div key={item.email} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-mono text-muted-foreground w-4">{idx + 1}</span>
                  <span className="text-sm truncate">{item.email}</span>
                </div>
                <Badge variant="secondary">{item.count} ops</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
